import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { GlobalService } from '../services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from '../../constant'
import * as moment from 'moment';


@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {
  consumerID:any;
  currentDate:any;
  refranceID:any;
  amount:any;

  resData:any=[];
  mandateData:any;
  isSuccess:boolean = false;
  constructor( private service: GlobalService,private spinner: NgxSpinnerService,private localStorageService: LocalStorageService,) { }

  ngOnInit() {
    this.resData = []
    if(localStorage.getItem('s2sResponse')){
      this.mandateData = JSON.parse(localStorage.getItem('s2sResponse'));
      this.resData.push(this.mandateData)
      this.saveRes();
    }   
  }

  ngOnDestroy() {
    localStorage.clear();
  }

  saveRes(){
    let url = Constant.saveMandateSign;
    if(this.mandateData){
      let reqObj = {
        "razorpay_PaymentId": this.mandateData.razorpay_payment_id,
        "razorpay_orderId": this.mandateData.razorpay_order_id,
        "razorpay_signiture": this.mandateData.razorpay_signature, 
    }
      this.spinner.show();
        this.service.PostService(url, reqObj).subscribe(response => {
          if (response) {
            this.spinner.hide();
            this.consumerID = '1234'
            this.currentDate = moment(new Date()).format('DD-MM-YYYY')
            this.refranceID = response.id
            this.amount = (response.token.max_amount/100)
            this.isSuccess = true;
          }
          else {
            alert(response.p_message);
          }
        })
    }
    
  }

}
